<template>
  <div>
    <v-container fluid grid-list-md>
      <v-layout column>
        <v-flex>
          <v-layout row wrap>
            <v-flex>
              <v-card raised>
                <v-card-title class="title">Reports</v-card-title>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex>
          <v-layout row>
            <v-flex>
              <v-card color="transparent">
                <v-card-title class="subheading">Reports</v-card-title>
                <v-divider></v-divider>
                <v-card-text align="left">
                  <v-layout row>
                    <v-flex>
                      <button class="btn btn-danger" @click='exportHeartRate'>DOWNLOAD HEART RATE REPORT</button>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import mixins from '@/mixins.js'
  import ReportService from '@/services/ReportService'
  import moment from 'moment'

  export default {
    data() {
      return {
        error: ''
      }
    },
    mixins: [mixins],
    async mounted() {
      try {
        this.error = ''
      } catch (error) {
        this.error = this.handleError(error)
      }
    },
    methods: {
      async exportHeartRate() {
        try {
          this.error = ''
          let tableHeader = [
          {
            colname: 'deviceId',
            coltext: 'Device ID',
          },
          {
            colname: 'deviceSerial',
            coltext: 'Device Serial',
          },
          {
            colname: 'careUserName',
            coltext: 'Care User',
          },
          {
            colname: 'heartRateValue',
            coltext: 'Heart Rate',
          },
          {
            colname: 'heartRateAccuracy',
            coltext: 'Heart Rate Accuracy',
          },
          {
            colname: 'logType',
            coltext: 'Log Type',
          },
          {
            colname: 'deviceTimestamp',
            coltext: 'Device Timestamp',
          },
          {
            colname: 'createdAt',
            coltext: 'Database Created Time',
          }
          ]
          var items = []
          var heartrates = (await ReportService.allheartrates()).data
          if (heartrates) {
            var devices = (await ReportService.alldevices()).data
            for (var i = 0; i < heartrates.length; i++) {
              var device_id = heartrates[i].deviceId
              var device_serial = this.showDeviceSerial(devices,device_id)
              var care_user_name = this.showDeviceCareUser(devices,device_id)
              var heart_rate_value = heartrates[i].heartRate
              var heart_rate_accuracy = heartrates[i].heartRateAccuracy
              var log_type = this.showLogType(heartrates[i].logType)
              var device_time_stamp = this.unixtimeAt(heartrates[i].deviceTimestamp)
              var created_dt = this.localAt(heartrates[i].createdAt)
              var item = {
                deviceId: device_id,
                deviceSerial: device_serial,
                careUserName: care_user_name,
                heartRateValue: heart_rate_value,
                heartRateAccuracy: heart_rate_accuracy,
                logType: log_type,
                deviceTimestamp: device_time_stamp,
                createdAt: created_dt
              }
              items.push(item)
            }
            var csv = '\ufeff';
            var keys = [];
            tableHeader.forEach(function(item) {
                csv += '"' + item.coltext + '",';
                keys.push(item.colname);
            });
            csv = csv.replace(/\,$/, '\n');
            items.forEach(function(item) {
                var _item = {};
                keys.forEach(function(key) {
                    csv += '"' + item[key] + '",';
                });
                csv = csv.replace(/\,$/, '\n');
            });
            csv = csv.replace(/"null"/g, '""');
            var blob = new Blob([csv], {
                type: 'text/csv,charset=UTF-8'
            });
            var csvUrl = window.URL.createObjectURL(blob);
            var a = document.createElement('a');
            var now = new Date();

            function to2(num) {
                return num > 9 ? num : '0' + num;
            }
            a.download = 'vsmp_report_heart_rate_' + now.getFullYear() + to2((now.getMonth() + 1)) + to2(now.getDate()) + to2(now.getHours()) + to2(now.getMinutes()) + to2(now.getSeconds()) + '.csv';
            a.href = csvUrl;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          }
        } catch (error) {
          this.error = this.handleError(error)
        }
      },
      localAt: function(time) {
        return moment(time).format("YYYY-MM-DD HH:mm:ss.SSS A")
      },
      unixtimeAt: function(time) {
        return moment(time).format("YYYY-MM-DD HH:mm:ss.SSS A")
      },
      showDeviceCareUser: function(devices,device_id) {
        if (devices) {
          for (var i = 0; i < devices.length; i++) {
            if (device_id === devices[i].deviceId) {
              if (devices[i].careUser) {
                return devices[i].careUser.firstName + ' ' + devices[i].careUser.lastName
              } else {
                return ''
              }
            }
          }
        }
        return ''
      },
      showDeviceSerial: function(devices,device_id) {
        if (devices) {
          for (var i = 0; i < devices.length; i++) {
            if (device_id === devices[i].deviceId) {
              if (devices[i].serial) {
                return devices[i].serial
              } else {
                return ''
              }
            }
          }
        }
        return ''
      },
      showLogType: function(logType) {
        if (logType) {
          if (logType === 9011) {
            return 'Distress Call (9011)'
          } else if (logType === 9021) {
            return 'Low Heart Rate (9021)'
          } else if (logType === 9022) {
            return 'High Heart Rate (9022)'
          } else if (logType === 9031) {
            return 'High Rotation (9031)'
          } else if (logType === 9032) {
            return 'High Acceleration (9032)'
          } else if (logType === 9033) {
            return 'High Gravity (9033)'
          } else if (logType === 9034) {
            return 'Low Gravity (9034)'
          } else if (logType === 9039) {
            return 'Fall (9039)'
          } else {
            return 'Normal Hear Rate (' + logType + ')'
          }
        } else {
          return 'Unknown Type'
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/SystemAdmin/Reports.vue